import { useMemo, useState } from "react";
import { NumField } from "@/components/tool/CalcFields";
import { RECIPES, scaleRecipe } from "@/lib/science/buffers";
import { m } from "@/paraglide/messages";
import { getLocale } from "@/paraglide/runtime";

export function BufferRecipeCalc() {
  const locale = getLocale();
  const [recipeId, setRecipeId] = useState(RECIPES[0].id);
  const [volume, setVolume] = useState("500");

  const recipe = RECIPES.find((r) => r.id === recipeId) ?? RECIPES[0];
  const scaled = useMemo(
    () => scaleRecipe(recipe, Number(volume)),
    [recipe, volume],
  );

  const num = (n: number) =>
    n.toLocaleString(locale, { maximumFractionDigits: 2 });

  return (
    <div className="sci-card rounded-2xl space-y-4 p-6 sm:p-8">
      <div className="grid gap-4 sm:grid-cols-2">
        <div className="space-y-1.5">
          <label
            htmlFor="recipe"
            className="block text-sm text-muted-foreground"
          >
            {m.buf_recipe()}
          </label>
          <select
            id="recipe"
            value={recipeId}
            onChange={(e) => setRecipeId(e.target.value)}
            className="w-full rounded-md border border-black/15 bg-white px-3 py-2 text-sm text-neutral-900"
          >
            {RECIPES.map((r) => (
              <option key={r.id} value={r.id}>
                {r.name}
              </option>
            ))}
          </select>
        </div>
        <NumField
          id="volume"
          label={m.buf_volume()}
          value={volume}
          onChange={setVolume}
          suffix="mL"
        />
      </div>

      {scaled ? (
        <div className="sci-result-zone space-y-1 rounded-xl px-5 py-4">
          <p className="mb-2 text-sm font-medium text-muted-foreground">
            {m.buf_to_make({ vol: num(Number(volume)), name: recipe.name })}
          </p>
          <ul data-testid="buf-result" className="space-y-1.5">
            {scaled.map((ing) => (
              <li
                key={ing.name}
                className="flex items-baseline justify-between gap-4"
              >
                <span className="text-sm">{ing.name}</span>
                <span className="sci-result font-mono font-semibold">
                  {num(ing.amount)} {ing.unit}
                </span>
              </li>
            ))}
          </ul>
        </div>
      ) : (
        <p className="text-sm text-muted-foreground">{m.buf_hint()}</p>
      )}

      {recipe.ph ? (
        <p className="text-xs text-muted-foreground">
          {m.buf_ph()}: {recipe.ph}
        </p>
      ) : null}
      <p className="text-xs text-muted-foreground">{recipe.note}</p>
    </div>
  );
}
